// 使用情境：當打圖片時，因為要將前台的圖片打到後台，所以API前會加ADMIN_URL
// 對應到後台：.env -> APP_URL
if(process.env.NODE_ENV === 'development') {
  window.globalData.APP_ADMIN_URL = "http://admin.ipetbooking.test/";
  window.globalData.APP_ENV = "local";
}

